import { useState } from 'react'
import clsx from 'clsx'

interface Tab {
  key: string
  label: string
  content: React.ReactNode
  hidden?: boolean
}

export function Tabs({ tabs, initial }: { tabs: Tab[]; initial?: string }) {
  const visible = tabs.filter((t) => !t.hidden)
  const [active, setActive] = useState(initial ?? visible[0]?.key ?? '')

  return (
    <div>
      <div className="border-b border-kh-gray-200 mb-4 flex gap-1 overflow-x-auto">
        {visible.map((t) => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            className={clsx(
              'px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors',
              active === t.key
                ? 'border-kh-gold text-kh-blue'
                : 'border-transparent text-kh-gray-500 hover:text-kh-gray-700 hover:border-kh-gray-200'
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div>{visible.find((t) => t.key === active)?.content}</div>
    </div>
  )
}
